import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
var _excluded = ["value", "onChange"],
  _excluded2 = ["fieldProps"],
  _excluded3 = ["value", "onChange"],
  _excluded4 = ["fieldProps"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback } from 'react';
import Field from './field';
/**
 * __Checkbox field__
 *
 * A checkbox field is a form field that lets users select an item. Users can check or uncheck the checkbox.
 *
 * - [Examples] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Code] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Usage] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 */
var CheckboxField = function CheckboxField(_ref) {
  var children = _ref.children,
    _ref$defaultIsChecked = _ref.defaultIsChecked,
    defaultIsChecked = _ref$defaultIsChecked === void 0 ? false : _ref$defaultIsChecked,
    isDisabled = _ref.isDisabled,
    isRequired = _ref.isRequired,
    label = _ref.label,
    name = _ref.name,
    value = _ref.value;
  // Maintains a memoised list of the default values
  var defaultValue = useCallback(function () {
    var currentValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return defaultIsChecked && value !== undefined ? [].concat(_toConsumableArray(currentValue), [value]) : currentValue;
  }, [value, defaultIsChecked]);
  return value !== undefined ? /*#__PURE__*/React.createElement(Field, {
    defaultValue: defaultValue,
    isDisabled: isDisabled,
    isRequired: isRequired,
    label: label,
    name: name,
    transform: function transform(event, currentValue) {
      return !Array.isArray(event) && event.currentTarget.checked && currentValue ? [].concat(_toConsumableArray(currentValue), [value]) : currentValue.filter(function (v) {
        return v !== value;
      });
    }
  }, function (_ref2) {
    var _ref2$fieldProps = _ref2.fieldProps,
      fieldValue = _ref2$fieldProps.value,
      _onChange = _ref2$fieldProps.onChange,
      otherFieldProps = _objectWithoutProperties(_ref2$fieldProps, _excluded),
      others = _objectWithoutProperties(_ref2, _excluded2);
    return children(_objectSpread({
      fieldProps: _objectSpread(_objectSpread({}, otherFieldProps), {}, {
        // Setting to any because it's typed weirdly at the field level
        onChange: function onChange(v) {
          return _onChange(v);
        },
        isChecked: !!fieldValue.find(function (v) {
          return v === value;
        }),
        value: value
      })
    }, others));
  }) : /*#__PURE__*/React.createElement(Field, {
    defaultValue: defaultIsChecked,
    isDisabled: isDisabled,
    isRequired: isRequired,
    label: label,
    name: name,
    transform: function transform(event) {
      return typeof event === 'boolean' ? event : event.currentTarget.checked;
    }
  }, function (_ref3) {
    var _ref3$fieldProps = _ref3.fieldProps,
      fieldValue = _ref3$fieldProps.value,
      _onChange2 = _ref3$fieldProps.onChange,
      otherFieldProps = _objectWithoutProperties(_ref3$fieldProps, _excluded3),
      others = _objectWithoutProperties(_ref3, _excluded4);
    return children(_objectSpread({
      fieldProps: _objectSpread(_objectSpread({}, otherFieldProps), {}, {
        // Setting to any because it's typed weirdly at the field level
        onChange: function onChange(v) {
          return _onChange2(v);
        },
        isChecked: fieldValue,
        value: value
      })
    }, others));
  });
};
export default CheckboxField;